import React from "react";
import { useNavigate } from "react-router-dom";
import PrivacyImage from '../assets/PrivacyPolicy.jpg'; // Adjust if the path is different

const Terms_Condition = () => {
    const navigate = useNavigate();

    const handleBackToHome = () => {
        navigate("/");
    };

    return (
        <>
            {/* Header Image Section */}
            <div className="w-full bg-white rounded-md overflow-hidden">
                <div className="relative w-full h-[300px]">
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-80"
                        style={{ backgroundImage: `url(${PrivacyImage})` }}
                    ></div>

                    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white text-center px-4">
                        <h1 className="text-3xl font-semibold">Terms and Condition for Besto HRMS</h1>
                        <button
                            onClick={handleBackToHome}
                            className="bg-gradient-to-r from-[#0d1d3c] to-[#0c3483] mt-4 px-5 py-2 hover:bg-blue-600 transition text-white rounded-md w-auto"
                        >
                            Back to Home Page
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Privacy Policy Content */}
            <div className="max-w-5xl mx-auto my-8 p-6 bg-gray-100 rounded-md shadow-md text-base leading-relaxed">
                <p className="mb-4">Effective Date: 11-05-2025

                </p>
                <p className="mb-4">
                    Welcome to <strong>Besto HRMS, </strong>a cloud-based Human Resource Management System owned and operated by <strong>Bestowal Systems and Services Private Limited</strong> (“we,” “us,” “our”). These Terms and Conditions (“Terms”) govern your access to and use of our website, platform, mobile applications, and any related services (collectively, the “Services”).
                    <br />
                    By accessing or using <strong>Besto HRMS,</strong> you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use our Services.

                </p>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Eligibility
                    </h2>
                    <p>
                        You must be at least 18 years old and capable of entering into a legally binding agreement to use the Services. By registering, you represent and warrant that you meet these requirements.                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Account Registration and Responsibilities


                    </h2>
                    <p className="text-left">To access the full features of Besto HRMS, you must create an account and provide accurate, complete, and up-to-date information. You are responsible for:

                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Maintaining the confidentiality of your login credentials







                        </li>
                        <li>Ensuring that any activities that occur under your account comply with these Terms








                        </li>
                        <li>Immediately notifying us of any unauthorized use or breach of security



                        </li>

                    </ul>
                    <p>We are not liable for any loss or damage arising from your failure to comply with this obligation.

                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Use of Services



                    </h2>
                    <p className="text-left">You agree to use the Services only for lawful purposes and in accordance with all applicable laws and regulations. You must not:


                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Upload or share any content that is unlawful, offensive, or violates the rights of others










                        </li>
                        <li>Attempt to gain unauthorized access to the platform or other user accounts











                        </li>
                        <li>Use the Service to send spam or unauthorized communications








                        </li>
                        <li>
                            Reverse engineer, decompile, or modify any part of the software or platform



                        </li>

                    </ul>

                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Data and Content Ownership

                    </h2>
                    <h4>
                        a. User Content

                    </h4>
                    <p>
                        You retain ownership of any data or content that you or your organization upload to the platform (“User Content”). You grant us a limited license to use, store, reproduce, and process your User Content solely to provide and improve the Services.

                    </p>
                    <h4>b. Our Content


                    </h4>
                    <p>
                        All intellectual property, trademarks, and content available through Besto HRMS (excluding User Content) is the property of Bestowal Systems and Services Private Limited and protected by applicable laws. You may not use, copy, or distribute our content without prior written permission.

                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Termination



                    </h2>
                    <p className="text-left">We may suspend or terminate your access to the Services at our sole discretion, with or without notice, if:


                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>You violate any provision of these Terms










                        </li>
                        <li>Required by law









                        </li>

                    </ul>
                    <p>Upon termination, your access to the platform and associated data may be revoked. It is your responsibility to back up any necessary data before termination.

                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Disclaimer of Warranties



                    </h2>
                    <p className="text-left">Besto HRMS is provided on an "as-is" and "as-available" basis. We make no warranties, express or implied, including but not limited to:



                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>The Service being uninterrupted, timely, secure, or error-free












                        </li>
                        <li>The results obtained from the use of the Service being accurate or reliable










                        </li>
                        <li>
                            The Service meeting your specific requirements



                        </li>

                    </ul>

                </section>


                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">7. Limitation of Liability




                    </h2>
                    <p className="text-left">To the maximum extent permitted by law, we are not liable for any indirect, incidental, punitive, or consequential damages arising out of:




                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Your use or inability to use the Services













                        </li>
                        <li>Unauthorized access to or alteration of your data













                        </li>
                        <li>
                            Any errors or omissions in the Service





                        </li>

                    </ul>
                    <p>Our total liability in any matter relating to the Services shall be limited to the amount paid by you in the last 12 months, if any.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">8. Limitation of Liability




                    </h2>
                    <p className="text-left">You agree to indemnify and hold harmless Bestowal Systems and Services Private Limited, its officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, and expenses arising from:





                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Your use of the Services















                        </li>
                        <li>Your violation of these Terms
















                        </li>
                        <li>
                            Your infringement of any third-party rights







                        </li>

                    </ul>

                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">9. Privacy Policy





                    </h2>
                    <p>
                        Your use of the Services is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data. By using the Services, you consent to the practices described therein.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">10. Third-Party Services




                    </h2>
                    <p>
                        Our platform may contain links or integrations with third-party applications or services. We are not responsible for the availability, content, or practices of any third-party services. Your use of such services is subject to their respective terms and policies.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">11. Changes to Terms



                    </h2>
                    <p>
                        We reserve the right to update or modify these Terms at any time. Changes will be posted on this page with an updated effective date. Continued use of the Services after such changes constitutes your acceptance of the new Terms.
                    </p>
                </section>
                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">12. Governing Law and Jurisdiction



                    </h2>
                    <p>
                        These Terms shall be governed by the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the courts located in Pune, India.                    </p>
                </section>
                <section className="mb-4">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">13. Contact Us</h2>
                    <p className="mb-2">If you have any questions, concerns, or complaints regarding this Privacy Policy or our data handling practices, please contact:
                    </p>
                    <ul className="list-disc ml-5 text-gray-700 space-y-2">
                        <li>Email: <a href="mailto:contact@bestowalsystems.com/ hr@bestowalsystems.com 
" className="text-blue-500 hover:underline"></a>contact@bestowalsystems.com / hr@bestowalsystems.com
                        </li>
                        <li>Phone:+91 94055 30011
                        </li>
                        <li>Address: 2nd Floor, Office No.21, Wadhwani Plaza, Near Ambedkar chowk, Pimpri, Pune, Maharashtra, India - 411018.</li>
                    </ul>
                </section>
            </div>
        </>
    );
};

export default Terms_Condition;
